import { phoneMask } from '../../../../../../shared';

export const formatInputValueByType = (value, type) => {
    if (type === 'tel') {
        return phoneMask(value);
    }

    return value;
};
